import React from "react";
import { css } from "@emotion/react";
import { Button, Font } from "@moneyforward/mfx_biz_react_components";

type Props = {
  onClick: () => void;
  loading: boolean;
};

export const BizsolReconnectButton = ({ onClick, loading }: Props) => {
  return (
    <div
      css={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <Font variant="m" component="span" css={authorityName}>
        連携済み
      </Font>
      <Button
        type="button"
        variant="secondary"
        onClick={onClick}
        disabled={loading}
      >
        再連携
      </Button>
    </div>
  );
};

const authorityName = css({
  marginRight: "10px",
});
